export default "__VITE_ASSET__CCmU78t6__"